import { Check } from 'lucide-react';

interface Alternativa {
  id: string;
  texto: string;
  emoji: string | null;
  ordem: number;
}

interface PerguntaCardProps {
  enunciado: string;
  alternativas: Alternativa[];
  selecionada: string | undefined;
  onSelecionar: (alternativaId: string) => void;
}

const LETRAS = ['A', 'B', 'C', 'D', 'E', 'F'];

export function PerguntaCard({
  enunciado,
  alternativas,
  selecionada,
  onSelecionar,
}: PerguntaCardProps) {
  return (
    <fieldset className="space-y-4">
      <legend className="text-lg font-semibold text-gray-900 sm:text-xl">{enunciado}</legend>

      <div className="space-y-2">
        {alternativas.map((alternativa, indice) => {
          const ativa = selecionada === alternativa.id;

          return (
            <button
              key={alternativa.id}
              type="button"
              onClick={() => onSelecionar(alternativa.id)}
              aria-pressed={ativa}
              className={`flex w-full items-center gap-3 rounded-lg border px-4 py-3 text-left transition-colors ${
                ativa
                  ? 'border-primary-600 bg-primary-50 ring-1 ring-primary-600'
                  : 'border-gray-200 bg-white hover:border-primary-300 hover:bg-gray-50'
              }`}
            >
              <span
                className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm font-semibold ${
                  ativa ? 'bg-primary-600 text-white' : 'bg-gray-100 text-gray-600'
                }`}
              >
                {ativa ? <Check className="h-4 w-4" /> : LETRAS[indice]}
              </span>

              {alternativa.emoji && (
                <span className="shrink-0 text-xl" aria-hidden="true">
                  {alternativa.emoji}
                </span>
              )}

              <span className="text-sm text-gray-800 sm:text-base">{alternativa.texto}</span>
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
